import Vue from 'vue';
import VueCurrencyFilter from 'vue-currency-filter';

import slots from '@topgeschenken/front-library/mixins/slot';
import security from '@topgeschenken/front-library/mixins/security';
import formValidation from '../mixins/formValidation';

Vue.mixin(slots);
Vue.mixin(security);
Vue.mixin(formValidation);

Vue.use(VueCurrencyFilter);

Vue.filter('date_format', (dateArg, locale, options = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
}) => {
  const date = typeof dateArg === 'string' ? new Date(dateArg) : dateArg;

  return new Intl.DateTimeFormat(locale, options).format(date);
});

Vue.filter('capitalize', (string) => {
  if (typeof string !== 'string') { return '' }

  return string.charAt(0).toUpperCase() + string.slice(1);
});

Vue.filter('removeSpaces', (string) => string.replace(/\s/g, ''));
